<div class="sc-footer">
  <div class="sc-footer-content">
    <div class="sc-footer-copyright caption2Font">
      <div i18n>
        &#169; {{ currentYear }} Trans Tech Publications Ltd. All rights are reserved, including those for text and
        data mining, AI training, and similar technologies.
        For open access content, terms of the Creative Commons licensing CC-BY are applied.
        <br />Scientific.Net is a registered trademark of Trans Tech Publications Ltd.
      </div>
    </div>
  </div>
</div>